<template>
  <BaseModal
    :is-open="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="true"
    :close-on-escape="true"
    :showCloseButton="true"
    content-padding="none"
    size="sm"
    title="계좌 개설"
    @close="handleCancel"
  >
    <div class="gap-size-36 pt-size-50 pb-size-40 px-size-50 flex flex-col">
      <div class="gap-size-12 flex flex-col items-center justify-center">
        <p class="text-font-16 font-medium">화면을 벗어나면 계좌 개설이 취소돼요</p>
      </div>
      <!-- 버튼 영역 -->
      <div class="gap-size-10 flex w-full items-center justify-center">
        <BaseButton
          label="확인"
          variant="contained"
          color="primary"
          size="md"
          @click="handleConfirm"
        />
        <BaseButton label="취소" variant="outlined" color="black" size="md" @click="handleCancel" />
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { BaseModal, BaseButton } from '@template/ui';

const isOpen = defineModel<boolean>('isOpen', { required: true, default: false });

interface Emits {
  (e: 'confirm', confirmed: boolean): void;
  (e: 'update:isOpen', value: boolean): void;
}

const emit = defineEmits<Emits>();

/**
 * 확인 버튼 클릭 핸들러
 * 라우트 이동을 허용합니다.
 */
const handleConfirm = () => {
  emit('confirm', true);
  emit('update:isOpen', false);
};

/**
 * 취소 버튼 클릭 핸들러
 * 라우트 이동을 차단합니다.
 */
const handleCancel = () => {
  emit('confirm', false);
  emit('update:isOpen', false);
};
</script>
